import type { ComponentType } from "react";
import { Info, CheckCircle2, AlertTriangle, AlertCircle } from "lucide-react";
import type { NotifyVariant } from "@/types/notify.types";

export interface VariantSpec {
  bgClass: string;
  borderClass: string;
  textClass: string;
  accentClass: string;
  icon: ComponentType<{ className?: string }>;
  ariaRole: "status" | "alert";
  ariaLive: "polite" | "assertive";
}

export const NOTIFY_VARIANT_TOKENS: Record<NotifyVariant, VariantSpec> = {
  info: {
    bgClass: "bg-rd-info-50",
    borderClass: "border-rd-info-500/30",
    textClass: "text-text-primary",
    accentClass: "text-rd-info-700",
    icon: Info,
    ariaRole: "status",
    ariaLive: "polite",
  },
  success: {
    bgClass: "bg-rd-success-50",
    borderClass: "border-rd-success-500/30",
    textClass: "text-text-primary",
    accentClass: "text-rd-success-700",
    icon: CheckCircle2,
    ariaRole: "status",
    ariaLive: "polite",
  },
  warning: {
    bgClass: "bg-rd-warning-50",
    borderClass: "border-rd-warning-500/30",
    textClass: "text-text-primary",
    accentClass: "text-rd-warning-700",
    icon: AlertTriangle,
    ariaRole: "alert",
    ariaLive: "polite",
  },
  danger: {
    bgClass: "bg-rd-danger-50",
    borderClass: "border-rd-danger-500/30",
    textClass: "text-text-primary",
    accentClass: "text-rd-danger-700",
    icon: AlertCircle,
    ariaRole: "alert",
    ariaLive: "assertive",
  },
};
